import axios, { AxiosError } from 'axios'

import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from 'interceptors'
import { CUSTOMER_PATH, TAX_PLAN_CUSTOMER_PATH } from '../../constants/paths'

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getTaxPlanCustomerByCustomerIdService = async (id: any) => {
  try {
    const result = await instance.get(TAX_PLAN_CUSTOMER_PATH + CUSTOMER_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createTaxPlanCustomer = async (taxPlanCustomer: any) => {
  try {
    const result = await instance.post(TAX_PLAN_CUSTOMER_PATH, taxPlanCustomer)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteTaxPlanCustomer = async (id: any) => {
  try {
    const result = await instance.delete(TAX_PLAN_CUSTOMER_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
